<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Latest Links</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover" id="money-sites">
          <thead>
          <tr>
            <th>Site</th>
            <th>Post</th>
            <th>Anchor</th>
            <th>Href</th>
            <th>Found</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="post in posts" :key="post.id">
            <td :title="post.title">
              <span class="label label-success">{{ post.language }}</span>
              {{ shorten(post.title, 30) }}
              <a :href="post.url" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td>
              <router-link :to="'/pbn/' + post.pbn.punyDomain">{{ post.pbn.domain }}</router-link>
              <a :href="'https://' + post.pbn.domain" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td>{{ post.pbn.group ? post.pbn.group.name : '/' }}</td>
            <td>{{ post.created.date | moment('from') }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import axios from 'axios'
import { Query, Values } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      posts: []
    }
  },
  mixins: [Query, Values],
  mounted () {
  },
  watch: {
    filters: function () {
    }
  },
  computed: {
    ...mapGetters({
      filters: 'getViewFilters'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/LatestLinks.vue